export default "__VITE_ASSET__CGYzqoz$__"